export default __webpack_public_path__ + "dae5c73b3cd589e97c636e9fe9fa5b60.svg";